<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>再エネ賦課金登録状況一覧</mat-card-title>
    </mat-card-header>
    <div class='table-responsive'>
        <table mat-table multiTemplateDataRows [dataSource]="dataSource" matSort style="width: 60%;margin-left: 20px;"
            #sort="matSort">
            <ng-container matColumnDef="apprvStsAname">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>ステータス</th>
                <td mat-cell *matCellDef="let e">{{ e.apprvStsAname }}</td>
            </ng-container>
            <ng-container matColumnDef="applyYm">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>適用年度</th>
                <td mat-cell *matCellDef="let e">{{ e.applyYm }}</td>
            </ng-container>
            <ng-container matColumnDef="applyStartDate">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>適用開始年月日</th>
                <td mat-cell *matCellDef="let e">{{ e.applyStartDate | dateString }}</td>
            </ng-container>
            <ng-container matColumnDef="applyEndDate">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>適用終了年月日</th>
                <td mat-cell *matCellDef="let e">{{ e.applyEndDate | dateString }}</td>
            </ng-container>
            <ng-container matColumnDef="slideadjustmentunitprice">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>単価[円]</th>
                <td mat-cell *matCellDef="let e" class="text-right">{{ e.slideadjustmentunitprice | number:'1.2-2' }}
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true;"></tr>
            <tr mat-row class="clickable-mat-row" *matRowDef="let row; columns: displayedColumnsCol"
                (dblclick)="onDbClickRow(row)"></tr>
        </table>
    </div>
    <mat-card-content>



    </mat-card-content>
</mat-card>